import React from 'react';
import { Link } from 'react-router-dom';
import CTAButtons from './CTAButtons';
import Logo from './Logo';

const LandingNavbar = () => {
  return (
    <nav className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-100">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center py-2">
            <Logo size="default" />
          </div>

          <div className="flex items-center gap-4">
            <CTAButtons className="" buttonText="Register My Trademark" />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default LandingNavbar;